export default {
    state: {
      isCheckout: false,
      checkoutPath: null,
      checkoutAddress: null,
    },
    mutations: {
      SET_IS_CHECKOUT: (state, isCheckout) => {
        state.isCheckout = isCheckout
      },
      SET_CHECKOUT_PATH: (state, checkoutPath) => {
        state.checkoutPath = checkoutPath
      },
      SET_CHECKOUT_ADDRESS: (state, checkoutAddress) => {
        state.checkoutAddress = checkoutAddress
      }
    },
    actions: {
      setIsCheckout ({ commit }, isCheckout) {
        commit('SET_IS_CHECKOUT', isCheckout)
      },
      setCheckoutPath ({ commit }, checkoutPath) {
        commit('SET_CHECKOUT_PATH', checkoutPath)
      },
      setCheckoutAddress ({ commit }, checkoutAddress) {
        commit('SET_CHECKOUT_ADDRESS', checkoutAddress)
      }
    }
  }
  